import React from "react";
import ReactDOM from "react-dom/client";
import "./index.scss";
import "./App.scss";
import { router } from "./routes";
import { RouterProvider } from "react-router-dom";

// Gör så att TypeScript vet att "root" kan inte vara null
const rootElement = document.getElementById("root");

if (rootElement) {
  const root = ReactDOM.createRoot(rootElement as HTMLElement);

  root.render(
    <React.StrictMode>
      <RouterProvider router={router} />
    </React.StrictMode>
  );
}

// Performance-analys
// reportWebVitals(console.log);
